import GameUtil from "../../../../../utility/game_util";
import ComponentBase from "../../../../public/component/component_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BullResultCom extends ComponentBase {
    
    @property(cc.Animation)
    finishAnimation : cc.Animation = null;;

    @property(cc.Animation)
    startAnimation : cc.Animation = null;
    
    @property(cc.Label)
    resultLabel : cc.Label = null;


    startPlay( resultNum? : number , callback? : Function){

        this.node.active = true;
        
        let name = this.startAnimation.getClips()[0].name;
        console.log(" startPlay " , name);
        this.startAnimation.play(name);
        
        let currency = GameUtil.currencyFormatting(resultNum);
        this.resultLabel.string  = resultNum > 0 ? "+" +  currency : currency;

        let self = this;
        this.doScheduleOnce(()=>{
            if (self && self.isValid && self.node.active) {
                
                let name = this.startAnimation.getClips()[1].name;
                self.startAnimation.play(name);
                //self.startAnimation.resume();
                console.log(" startPlay " , name);
                self.doScheduleOnce(()=>{
                    if (self && self.isValid && self.node.active) {
                        if (callback) {
                            callback();
                        }
                    }
                },0.5)               
            }
        },3);

    }

    onDisable(){

        this.cancelAllSchedule();
    }


}
